import styled from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export const ScDatePickerItem = styled.div<{ secondary?: boolean }>`
  position: relative;
  z-index: 1;

  .data-picker-wrapper {
    position: absolute;
    left: 0;
    top: calc(100% + 8px);
    width: 100%;
    background-color: ${({ theme }) => theme.grayLightColor};
    border-radius: 24px;
    box-shadow: ${({ theme }) =>
      `0px 2px 10px 0px ${hexToRGB(theme.blackColor, 0.3)}`};
    border: 2px solid ${({ theme }) => theme.grayColor};
  }

  .react-datepicker {
    width: fit-content;
    background-color: ${({ theme, secondary }) =>
      secondary ? theme.color3 : theme.grayLightColor};
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    border-radius: 24px;
    border: 0;
    display: flex;
    padding: 0;
    margin: 0 auto;
    width: 100%;
  }

  .react-datepicker__month-container {
    width: 100%;
    padding: 16px;
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__day-names {
    display: flex;
  }
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: ${({ theme }) => theme.blackLightColor};
    aspect-ratio: 1/1;
  }

  .react-datepicker__day--today {
    color: white;
    font-weight: 400;
  }

  .react-datepicker__day-name {
    color: ${({ theme }) => theme.whiteColor};
    aspect-ratio: 1/1;
  }

  .react-datepicker__month-container {
    float: none;
  }

  .react-datepicker__week {
    overflow: hidden;
    display: flex;
  }

  .react-datepicker__day,
  .react-datepicker__day-name {
    width: 100%;
    height: 100%;
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    place-items: center;
    border: 2px solid transparent;
    background-color: transparent;
  }

  .react-datepicker__day {
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      background-color: ${({ theme }) => theme.blackColor};
      border-radius: 360px;
      color: ${({ theme }) => theme.whiteColor};

      &.react-datepicker__day--in-range {
        border-radius: 0;

        &:last-child {
          border-radius: 0 360px 360px 0;
        }

        &:first-child {
          border-radius: 360px 0 0 360px;
        }
      }

      &.react-datepicker__day--range-start,
      &.react-datepicker__day--selecting-range-start {
        border-radius: 360px 0 0 360px;
      }

      &.react-datepicker__day--range-end,
      &.react-datepicker__day--selecting-range-end {
        border-radius: 0 360px 360px 0;
      }

      &.react-datepicker__day--selecting-range-start.react-datepicker__day--range-end,
      &.react-datepicker__day--selecting-range-start.react-datepicker__day--selecting-range-end {
        border-radius: 360px;
      }
    }
  }

  .react-datepicker__day-name {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    text-transform: uppercase;
  }

  .react-datepicker__header {
    background-color: transparent;
    border-bottom: 0;
  }

  .react-datepicker__current-month {
    margin-bottom: 8px;
  }

  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range {
    background-color: transparent;
    position: relative;
    z-index: 1;
    background-color: ${({ theme, secondary }) =>
      secondary ? theme.grayLightColor : theme.blackColor} !important;
    border-radius: 0;

    &:first-child {
      border-radius: 360px 0 0 360px;
    }
    &:last-child {
      border-radius: 0 360px 360px 0;
    }
  }

  .react-datepicker__day--range-start,
  .react-datepicker__day--selecting-range-start {
    border-radius: 360px 0 0 360px;
  }

  .react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-end {
    border-radius: 0 360px 360px 0;
  }

  .react-datepicker__day--selecting-range-start.react-datepicker__day--selecting-range-end {
    border-radius: 360px;
  }

  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--selecting-range-end {
    color: ${({ theme }) => theme.whiteColor};

    z-index: 2;
    &:after {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      border-radius: 360px;
      border: 2px solid ${({ theme }) => theme.grayColor};
      display: block;
      z-index: -1;
    }
  }

  .react-datepicker__day--outside-month {
    color: ${({ theme }) => hexToRGB(theme.blackLightColor, 0.2)};
    pointer-events: none;

    &::after {
      content: none !important;
    }
  }
`;

export const ScCustomHeader = styled.div`
  display: flex;
  width: min(352px, 100%);
  margin-inline: auto;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.whiteColor};

  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.16px;

  & > .arrow {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    cursor: pointer;

    &:last-child > svg {
      transform: rotate(90deg);
    }

    &:first-child > svg {
      transform: rotate(-90deg);
    }
  }
`;
